import { isCesiumIonAssetType } from "./CesiumIonAssetType";
import { isCesiumIonAssetStatus } from "./CesiumIonAssetStatus";
/**
 * Returns whether the given object matches the CesiumIonAssetInfo type
 * @param obj Object to check
 */
export function isCesiumIonAssetInfo(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    if (typeof obj.id !== "undefined" && typeof obj.id !== "number")
        return false;
    if (typeof obj.name !== "string")
        return false;
    if (typeof obj.description !== "undefined" && typeof obj.description !== "string")
        return false;
    if (typeof obj.attribution !== "undefined" && typeof obj.attribution !== "string")
        return false;
    if (!isCesiumIonAssetType(obj.type))
        return false;
    if (typeof obj.bytes !== "undefined" && typeof obj.bytes !== "number")
        return false;
    if (typeof obj.dateAdded !== "undefined" && typeof obj.dateAdded !== "string")
        return false;
    if (!isCesiumIonAssetStatus(obj.status))
        return false;
    if (typeof obj.percentComplete !== "undefined" && typeof obj.percentComplete !== "number")
        return false;
    if (typeof obj.status !== "undefined" && !isCesiumIonAssetStatus(obj.status))
        return false;
    return true;
}
